/**
 * @generated SignedSource<<b0aaf079fcb4bc1c2b677132bb88eb7a>>
 * @relayHash 6d3cda5114c1d606399b11a6636db3e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7db31b068cec62e93fddfe2bcf08ccec80873bee7f945d8eae9bc25e7a1226c2

import type { ConcreteRequest } from 'relay-runtime';
export type shortcutsSmartLinksQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type shortcutsSmartLinksQuery$data = {
  readonly confluence_shortcutSmartLinksBySpaceKey: {
    readonly nodes: ReadonlyArray<{
      readonly canView: boolean | null;
      readonly customTitle: string | null;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly id: AGG$Long;
      readonly position: number;
      readonly product: string | null;
      readonly resolved: boolean | null;
      readonly resourceType: string | null;
      readonly styleClass: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type shortcutsSmartLinksQuery = {
  response: shortcutsSmartLinksQuery$data;
  variables: shortcutsSmartLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceShortcutSmartLinkConnection",
    "kind": "LinkedField",
    "name": "confluence_shortcutSmartLinksBySpaceKey",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceShortcutSmartLink",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "position"
          },
          {
            "kind": "ScalarField",
            "name": "styleClass"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "customTitle"
          },
          {
            "kind": "ScalarField",
            "name": "emojiTitle"
          },
          {
            "kind": "ScalarField",
            "name": "canView"
          },
          {
            "kind": "ScalarField",
            "name": "resolved"
          },
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "kind": "ScalarField",
            "name": "resourceType"
          },
          {
            "kind": "ScalarField",
            "name": "iconUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "shortcutsSmartLinksQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "shortcutsSmartLinksQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6d3cda5114c1d606399b11a6636db3e6",
    "id": "7db31b068cec62e93fddfe2bcf08ccec80873bee7f945d8eae9bc25e7a1226c2",
    "metadata": {},
    "name": "shortcutsSmartLinksQuery",
    "operationKind": "query",
    "text": "query shortcutsSmartLinksQuery($spaceKey:String!,$cloudId:ID!){confluence_shortcutSmartLinksBySpaceKey(spaceKey:$spaceKey,cloudId:$cloudId){nodes{id,position,styleClass,url,title,customTitle,emojiTitle,canView,resolved,product,subType,resourceType,iconUrl}}}"
  }
};
})();

(node as any).hash = "ca06046b2bc1366382e1193fad619c53";

export default node;
